var {AmpersandView} = require('catalog/libs');

/**
 * template for hit view
 */
var template = '<option value>/option>';

/**
 * collection of select hits
 */
var HitsCollectionView = AmpersandView.extend({

    render: function(opts) {
        this.renderCollection(this.collection, function(options) {
            return new HitView(options);
        }, this.el, opts);
        return this;
    }
});

/**
 * hit view
 */
var HitView = AmpersandView.extend({
    template: template,
    bindings: {
        'model.selectValue': {
            type: 'attribute',
            name: 'value',
            selector: 'option'
        },
        'model.selectLabel': {
            type: 'text',
            selector: 'option'
        },
        'model.isSelected': {
            type: function(el, value) {
                if (value) {
                    $(el).prop('selected', true);
                }
            },
            selector: 'option'
        }
    },

    initialize: function() {

    }
});

module.exports = HitsCollectionView;
